import { RouteObject } from "react-router-dom";

import Signin from "./signin";

export const routes: RouteObject[] = [
  { path: 'signin', element: <Signin />,
    handle: { title: 'Sign In' },
  },
];
